import React from 'react';
import { useTranslation } from 'react-i18next';
import CompactSelectPicker from '../ui/CompactSelectPicker';
import { Toggle } from '../settingsPrimitives';

/** Built-ins that cannot be attached, with the honest reason. */
const UNSUPPORTED = {
  cursor: ['terminalExt.mcpCursorReason', 'Cursor CLI reads MCP servers only from its own mcp.json, which Apiboo does not edit.'],
  grok: ['terminalExt.mcpGrokReason', 'Not available for Grok yet — its MCP configuration is not confirmed.'],
};

/**
 * "Attach Apiboo MCP" in the profile editor. Claude Code and Codex: a switch
 * (on by default). Cursor / Grok: shown disabled with the reason. A custom
 * profile chooses the style its CLI understands. The pane gets its OWN
 * short-lived token — the user's token is never shown or passed on.
 */
export default function ProfileMcpSection({ draft, onChange }) {
  const { t } = useTranslation();
  const reason = draft.builtin ? UNSUPPORTED[draft.id] : null;
  const note = t(
    'terminalExt.mcpAttachNote',
    'The agent gets a token for this pane only, with your current MCP grants. It lives in memory and ends with the pane. Needs the MCP server to be on.'
  );

  let control;
  if (reason) {
    control = <div className="term-field-hint">{t(reason[0], reason[1])}</div>;
  } else if (draft.builtin) {
    control = (
      <div className="term-field-toggle">
        <span className="term-field-hint">{note}</span>
        <Toggle value={draft.mcpAttach !== false} onChange={(v) => onChange({ mcpAttach: v })} />
      </div>
    );
  } else {
    const value = draft.mcpSupport && draft.mcpAttach !== false ? draft.mcpSupport : 'off';
    control = (
      <>
        <CompactSelectPicker
          value={value}
          aria-label={t('terminalExt.mcpAttach', 'Attach Apiboo MCP')}
          options={[
            { value: 'off', label: t('terminalExt.mcpStyleOff', 'Off') },
            { value: 'claude', label: t('terminalExt.mcpStyleClaude', 'Claude-style (--mcp-config)') },
            { value: 'codex', label: t('terminalExt.mcpStyleCodex', 'Codex-style (-c mcp_servers…)') },
          ]}
          onChange={(v) => onChange(v === 'off' ? { mcpSupport: null, mcpAttach: false } : { mcpSupport: v, mcpAttach: true })}
        />
        {value !== 'off' && <div className="term-field-hint">{note}</div>}
      </>
    );
  }

  return (
    <div className="term-field">
      <span className="modal-logo-label">{t('terminalExt.mcpAttach', 'Attach Apiboo MCP')}</span>
      {control}
    </div>
  );
}
